<span *ngIf="cell.wrapText; else noWrap" class="sh-wrap-text">
    <sh-html-parser [message]="value$ | async"></sh-html-parser>
</span>

<ng-template #noWrap>
    <sh-list-row-title [title]="value$ | async"></sh-list-row-title>
</ng-template>
